module.exports = __webpack_public_path__ + "img/Qt程序打包工具V1.0.70ea38e5.gif";